import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data
      .map(item => ({
        id: item.user.id,
        text: `${item.user.vaxiom_person.first_name} ${item.user.vaxiom_person.last_name}\u00A0\u00A0•\u00A0\u00A0${item.user.email}`,
        order_key: `${item.user.vaxiom_person.last_name} ${item.user.vaxiom_person.first_name}`,
      }))
      .sort((a, b) => a.order_key.localeCompare(b.order_key))
  }, [data])
}
